import styles from './progressBar.module.css';

const ProgressBar = ({ currentStep, totalSteps }) => {
  const shouldShowProgressBar = currentStep < totalSteps - 1;

  if (!shouldShowProgressBar) {
    return null;
  }

  const progressSteps = totalSteps - 1;
  const progressPercentage = (currentStep / (progressSteps - 1)) * 100;

  return (
    <>
      {/* Mobile question indicator */}
      <p className='sr-only'>{`Question ${currentStep + 1} of ${progressSteps}`}</p>
      <div aria-hidden className={styles.mobileIndicator}>
        Question {currentStep + 1} of {progressSteps}
      </div>

      {/* Desktop progress bar */}
      <div
        aria-hidden
        className={styles.progressContainer}
        data-steps={progressSteps}
      >
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${Math.min(progressPercentage, 100)}%` }}
          />
          {Array.from({ length: progressSteps }, (_, index) => (
            <div
              key={index}
              className={`${styles.progressStep} ${
                index <= currentStep ? styles.progressStepActive : ''
              }`}
            >
              <span className={styles.stepNumber}>{index + 1}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
